import { render, staticRenderFns } from "./ModalCongrats.vue?vue&type=template&id=6b2224e7&"
import script from "./ModalCongrats.vue?vue&type=script&lang=js&"
export * from "./ModalCongrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2224e7')) {
      api.createRecord('6b2224e7', component.options)
    } else {
      api.reload('6b2224e7', component.options)
    }
    module.hot.accept("./ModalCongrats.vue?vue&type=template&id=6b2224e7&", function () {
      api.rerender('6b2224e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/WebSite/Modal/ModalCongrats.vue"
export default component.exports